'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListCard = require('./components/ListCard.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListCard).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/card/list-card/lib/index.js
// module id = 988
// module chunks = 5